import { 
    useControl, useDirtyControl, 
    withValidator, 
    Model, ValidRules, Controller, DirtyController,
} from '../../core/Input';

import { InputConfig, InputColors, InputStyleConfig, InputStyleConfigP, Input } from './shared';

const base: Model<string> = {
    empty: '',
    putIn: (s) => s,
    putOut: (s) => s,
}

export {
    Input,
    Controller,
    DirtyController,
    useControl,
    useDirtyControl,
    withValidator,
    Model,
    ValidRules,
    base,
    InputConfig,
    InputColors,
    InputStyleConfig,
    InputStyleConfigP,
}